import React from "react";
import "../../pages/Surveys/style.css";
import cogoToast from "cogo-toast";
import { Label, Input, Button, Card, CardBody, CardHeader, Table, Badge, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useState, useEffect, useMemo, useRef } from "react";
import { ListStaffLightweightApi, ListStaffDetailsApi, UpdateStaffStatusApi, listStaffFileTypesApi, uploadStaffFileApi, listStaffFilesApi, downloadStaffFileApi, deleteStaffFileApi, genericPost } from "../../services/Api";

import { FaFileExport, FaArrowRight, FaSearch, FaTimes, FaUpload, FaFile, FaDownload, FaTrash, FaSort, FaSortUp, FaSortDown, FaEdit } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { LOCAL_PATHS, SUCCESS_RESULT } from "../../Constants";
import * as XLSX from 'xlsx';
import Swal from "sweetalert2";

const EmployeeList = (props) => {
  const history = useHistory();
  const [is_processing, setProcessing] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(10001); // 10001 = Active, 10002 = Inactive
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc"); // "asc" or "desc"
  const [staffDetails, setStaffDetails] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [selectedStaffId, setSelectedStaffId] = useState(null);
  const [officesList, setOfficesList] = useState([]);
  const [rolesList, setRolesList] = useState([]);
  const [departmentsList, setDepartmentsList] = useState([]);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [fileTypes, setFileTypes] = useState([]);
  const [isLoadingFileTypes, setIsLoadingFileTypes] = useState(false);
  const [uploadForm, setUploadForm] = useState({
    file: null,
    file_type_id: "",
    document_name: "",
    description: "",
  });
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [staffFiles, setStaffFiles] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showEditStaffDetailsModal, setShowEditStaffDetailsModal] = useState(false);
  const [isUpdatingStaffDetails, setIsUpdatingStaffDetails] = useState(false);
  const [staffEditForm, setStaffEditForm] = useState({
    staff_name: "",
    telephone: "",
    office_id: "",
    role_id: "",
    department_id: "",
    joined_at: "",
    blood_group: "",
    annual_leave_days: "",
  });
  const [selectedStaffIds, setSelectedStaffIds] = useState(new Set());
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);

  const normalizeStaffDetailsResponse = (payload) => {
    // New API may return { staff: {...}, offices:[], roles:[], departments:[] }
    // Older API returned the staff object directly.
    if (!payload || typeof payload !== "object") {
      return { staff: null, offices: [], roles: [], departments: [] };
    }

    const offices = Array.isArray(payload.offices) ? payload.offices : [];
    const roles = Array.isArray(payload.roles) ? payload.roles : [];
    const departments = Array.isArray(payload.departments) ? payload.departments : [];

    const staff =
      payload.staff_details ||
      payload.staff ||
      payload.employee ||
      payload.details ||
      payload.data ||
      payload;

    return { staff, offices, roles, departments };
  };

  useEffect(() => {
    fetch_data();
    // Clear selection when filter changes
    setSelectedStaffIds(new Set());
    return () => {};
  }, [statusFilter]);

  const fetch_data = () => {
    setProcessing(true);

    const payload = {
      status: statusFilter,
    };

    ListStaffLightweightApi(payload)
      .then((res) => {
        setProcessing(false);
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              setRowData([]);
              return;
            }

            setRowData(response.data || []);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
            setRowData([]);
          }
        } else {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          setRowData([]);
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
        setRowData([]);
      });
  };

  // Filter data based on search term
  const filteredData = useMemo(() => {
    let data = rowData;

    // Apply search filter
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      data = data.filter((employee) => {
        // Search across all fields
        const searchableFields = [
          employee.staff_id,
          employee.staff_name,
          employee.email,
          employee.role_name,
          employee.designation,
          employee.office_name,
          employee.office,
          employee.gender,
          employee.telephone,
          employee.passport,
          employee.blood_group,
          employee.contract_start_date,
          employee.contract_end_date,
          employee.files_count,
          employee.department_name,
          employee.joined_at,
        ];
        
        return searchableFields.some((field) => 
          field && String(field).toLowerCase().includes(searchLower)
        );
      });
    }

    // Apply sorting
    if (sortField) {
      data = [...data].sort((a, b) => {
        let aValue = a[sortField];
        let bValue = b[sortField];
        
        // Handle nested fields
        if (sortField === "department_name") {
          aValue = a.department_name;
          bValue = b.department_name;
        } else if (sortField === "joined_at") {
          aValue = a.joined_at;
          bValue = b.joined_at;
        }

        // Handle date sorting first (before string conversion)
        if (sortField === "joined_at") {
          aValue = a.joined_at ? new Date(a.joined_at).getTime() : 0;
          bValue = b.joined_at ? new Date(b.joined_at).getTime() : 0;
        } else if (sortField === "files_count") {
          // Handle numeric fields
          aValue = Number(a.files_count || 0);
          bValue = Number(b.files_count || 0);
        } else {
          // Handle null/undefined values for string fields
          if (aValue == null) aValue = "";
          if (bValue == null) bValue = "";
          // Convert to strings for comparison
          aValue = String(aValue).toLowerCase();
          bValue = String(bValue).toLowerCase();
        }

        // Compare values
        if (aValue < bValue) {
          return sortDirection === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortDirection === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return data;
  }, [rowData, searchTerm, sortField, sortDirection]);

  const handleSort = (field) => {
    if (sortField === field) {
      // Toggle direction if clicking the same field
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Set new field and default to ascending
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) {
      return <FaSort style={{ marginLeft: "4px", opacity: 0.3 }} />;
    }
    return sortDirection === "asc" ? (
      <FaSortUp style={{ marginLeft: "4px" }} />
    ) : (
      <FaSortDown style={{ marginLeft: "4px" }} />
    );
  };

  const handleExport = () => {
    if (!filteredData || filteredData.length === 0) {
      cogoToast.error("No data available to export", {
        hideAfter: 3,
      });
      return;
    }

    try {
      // Prepare data for Excel export
      const excelData = filteredData.map((row, index) => {
        return {
          '#': index + 1,
          'Staff ID': row.staff_id || '',
          'Staff Name': row.staff_name || '',
          'Email': row.email || '',
          'Telephone': row.telephone || '',
          'Designation': row.designation || row.role_name || '',
          'Department': row.department_name || '',
          'Joined At': row.joined_at ? formatDate(row.joined_at) : '',
          'Office': row.office || row.office_name || '',
          'Contract Start Date': row.contract_start_date ? formatDate(row.contract_start_date) : '',
          'Contract End Date': row.contract_end_date ? formatDate(row.contract_end_date) : '',
          'Files Count': row.files_count || 0,
        };
      });

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Set column widths
      ws['!cols'] = [
        { wch: 5 },   // #
        { wch: 12 },  // Staff ID
        { wch: 25 },  // Staff Name
        { wch: 30 },  // Email
        { wch: 15 },  // Telephone
        { wch: 25 },  // Designation
        { wch: 20 },  // Department
        { wch: 18 },  // Joined At
        { wch: 20 },  // Office
        { wch: 18 },  // Contract Start Date
        { wch: 18 },  // Contract End Date
        { wch: 12 },  // Files Count
      ];

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Employee List');

      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(wb, { 
        bookType: 'xlsx', 
        type: 'array',
        compression: true 
      });

      // Create blob and download
      const blob = new Blob([excelBuffer], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `EmployeeList-${window.h?.get_half_formattedDate?.() || new Date().toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      cogoToast.success("Excel file exported successfully", {
        hideAfter: 3,
      });
    } catch (error) {
      console.error('Excel export error:', error);
      cogoToast.error("Failed to export Excel file. Please try again.", {
        hideAfter: 5,
      });
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  const getContractStatusColor = (expiresAfter) => {
    const days = Number(expiresAfter);
    if (days < 30 && days > 10) {
      return "#E97451";
    } else if (days < 10 && days > 0) {
      return "#EE4B2B";
    } else if (days < 0) {
      return "red";
    }
    return null;
  };

  const fetchFileTypes = () => {
    setIsLoadingFileTypes(true);
    listStaffFileTypesApi({ status: 10001 })
      .then((res) => {
        setIsLoadingFileTypes(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setFileTypes(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load file types", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to load file types", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setIsLoadingFileTypes(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const fetchStaffFiles = (staffId = null) => {
    const idToUse = staffId || selectedStaffId;
    if (!idToUse) return;

    setIsLoadingFiles(true);
    listStaffFilesApi({ staff_id: idToUse })
      .then((res) => {
        setIsLoadingFiles(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            setStaffFiles(response.data || []);
          } else {
            cogoToast.error(response.message || "Failed to load staff files", {
          hideAfter: 5,
        });
            setStaffFiles([]);
          }
        } else {
          cogoToast.error(res.message || "Failed to load staff files", {
            hideAfter: 5,
          });
          setStaffFiles([]);
        }
      })
      .catch((err) => {
        setIsLoadingFiles(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
        setStaffFiles([]);
      });
  };

  const handleOpenDetails = (staffId) => {
    if (!staffId) {
      cogoToast.error("Staff ID is required", { hideAfter: 3 });
      return;
    }

    setSelectedStaffId(staffId);
    setIsPanelOpen(true);
    setIsLoadingDetails(true);
    setStaffDetails(null);
    setUploadForm({
      file: null,
      file_type_id: "",
      document_name: "",
      description: "",
    });
    setShowUploadForm(false);

    // Fetch file types and staff files
    fetchFileTypes();
    // Note: fetchStaffFiles will be called after selectedStaffId is set

    ListStaffDetailsApi({ staff_id: staffId })
      .then((res) => {
        setIsLoadingDetails(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            const normalized = normalizeStaffDetailsResponse(response.data);
            setOfficesList(normalized.offices);
            setRolesList(normalized.roles);
            setDepartmentsList(normalized.departments);
            setStaffDetails(normalized.staff);
            // Fetch staff files after details are loaded (pass staffId to ensure it's available)
            fetchStaffFiles(staffId);
          } else {
            cogoToast.error(response.message || "Failed to load staff details", {
          hideAfter: 5,
        });
            setIsPanelOpen(false);
          }
        } else {
          cogoToast.error(res.message || "Failed to load staff details", {
            hideAfter: 5,
          });
          setIsPanelOpen(false);
        }
      })
      .catch((err) => {
        setIsLoadingDetails(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
        setIsPanelOpen(false);
      });
  };

  const handleClosePanel = () => {
    setIsPanelOpen(false);
    setStaffDetails(null);
    setSelectedStaffId(null);
    setOfficesList([]);
    setRolesList([]);
    setDepartmentsList([]);
    setUploadForm({
      file: null,
      file_type_id: "",
      document_name: "",
      description: "",
    });
    setShowUploadForm(false);
    setStaffFiles([]);
  };

  const handleFileUpload = () => {
    if (!uploadForm.file) {
      cogoToast.error("Please select a file to upload", { hideAfter: 3 });
      return;
    }

    if (!uploadForm.file_type_id) {
      cogoToast.error("Please select a file type", { hideAfter: 3 });
      return;
    }

    if (!uploadForm.document_name || uploadForm.document_name.trim() === "") {
      cogoToast.error("Please enter a document name", { hideAfter: 3 });
      return;
    }

    setIsUploading(true);

    const formData = new FormData();
    formData.append('staff_id', selectedStaffId);
    formData.append('file', uploadForm.file);
    formData.append('document_name', uploadForm.document_name.trim());
    formData.append('file_type_id', uploadForm.file_type_id);
    if (uploadForm.description && uploadForm.description.trim() !== "") {
      formData.append('description', uploadForm.description.trim());
    }

    uploadStaffFileApi(formData)
      .then((res) => {
        setIsUploading(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success(response.message || "File uploaded successfully", {
              hideAfter: 3,
            });
            // Reset form
            setUploadForm({
              file: null,
              file_type_id: "",
              document_name: "",
              description: "",
            });
            // Reset file input
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            // Switch back to list view
            setShowUploadForm(false);
            // Refresh staff files list
            fetchStaffFiles();
            // Refresh staff details
            refreshStaffDetails();
          } else {
            cogoToast.error(response.message || "Failed to upload file", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to upload file", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setIsUploading(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const handleUploadFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file") {
      setUploadForm((prev) => ({
        ...prev,
        file: files && files.length > 0 ? files[0] : null,
      }));
    } else {
      setUploadForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleDownloadFile = (file) => {
    if (!file.id) {
      cogoToast.error("File ID is missing", { hideAfter: 3 });
      return;
    }

    // Show loading toast
    const loadingToast = cogoToast.loading("Opening file...", { hideAfter: 0 });

    downloadStaffFileApi({ file_id: file.id })
      .then((res) => {
        loadingToast.hide();
        
        // Get content type from response headers or default
        const contentType = res.headers?.['content-type'] || res.data?.type || 'application/octet-stream';
        
        // Create a blob from the response
        const blob = new Blob([res.data], { type: contentType });
        
        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);
        
        // Open file in new tab
        const newWindow = window.open(url, '_blank');
        
        // If popup was blocked, fall back to download
        if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
          // Fallback to download if popup blocked
          const link = document.createElement('a');
          link.href = url;
          link.download = file.file_name || file.document_name || 'download';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          cogoToast.info("Popup blocked. File downloaded instead.", { hideAfter: 3 });
        } else {
          cogoToast.success("File opened in new tab", { hideAfter: 3 });
        }
        
        // Clean up URL after a delay to allow the tab to load
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 1000);
      })
      .catch((err) => {
        loadingToast.hide();
        const errorMessage =
          err?.response?.data?.message || "Failed to open file. Please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const handleDeleteFile = (file) => {
    if (!file.id) {
      cogoToast.error("File ID is missing", { hideAfter: 3 });
      return;
    }

    // Use browser confirm dialog
    const confirmDelete = window.confirm(
      `Are you sure you want to delete "${file.document_name || file.file_name}"?\n\nThis action cannot be undone.`
    );

    if (!confirmDelete) {
      return;
    }

    // Show loading toast
    const loadingToast = cogoToast.loading("Deleting file...", { hideAfter: 0 });

    deleteStaffFileApi({ file_id: file.id })
      .then((res) => {
        loadingToast.hide();
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success(response.message || "File deleted successfully", { hideAfter: 3 });
            // Refresh staff files list
            fetchStaffFiles();
          } else {
            cogoToast.error(response.message || "Failed to delete file", { hideAfter: 5 });
          }
        } else {
          cogoToast.error(res.message || "Failed to delete file", { hideAfter: 5 });
        }
      })
      .catch((err) => {
        loadingToast.hide();
        const errorMessage =
          err?.response?.data?.message || "Failed to delete file. Please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const refreshStaffDetails = () => {
    if (!selectedStaffId) return;

    setIsLoadingDetails(true);
    ListStaffDetailsApi({ staff_id: selectedStaffId })
      .then((res) => {
        setIsLoadingDetails(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            const normalized = normalizeStaffDetailsResponse(response.data);
            setOfficesList(normalized.offices);
            setRolesList(normalized.roles);
            setDepartmentsList(normalized.departments);
            setStaffDetails(normalized.staff);
          } else {
            cogoToast.error(response.message || "Failed to refresh staff details", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to refresh staff details", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setIsLoadingDetails(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const handleStatusUpdate = () => {
    if (!selectedStaffId || !staffDetails) return;

    const newStatus = staffDetails.status === 10001 ? 10002 : 10001;
    setIsUpdatingStatus(true);

    UpdateStaffStatusApi({
      staff_id: selectedStaffId,
      status: newStatus,
    })
      .then((res) => {
        setIsUpdatingStatus(false);
        setShowStatusModal(false);
        if (res.status === 200) {
          const response = res.data;
          if (response.status === SUCCESS_RESULT) {
            cogoToast.success(
              `Staff ${newStatus === 10001 ? "activated" : "deactivated"} successfully`,
              { hideAfter: 3 }
            );
            // Refresh staff details
            refreshStaffDetails();
            // Refresh the main list
            fetch_data();
          } else {
            cogoToast.error(response.message || "Failed to update staff status", {
              hideAfter: 5,
            });
          }
        } else {
          cogoToast.error(res.message || "Failed to update staff status", {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setIsUpdatingStatus(false);
        setShowStatusModal(false);
        const errorMessage =
          err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const handleOpenEditStaffDetails = () => {
    if (!selectedStaffId || !staffDetails) {
      cogoToast.error("Staff details are missing", { hideAfter: 3 });
      return;
    }

    const toDateInputValue = (v) => {
      if (!v) return "";
      try {
        return new Date(v).toISOString().split("T")[0];
      } catch (e) {
        return "";
      }
    };

    setStaffEditForm({
      staff_name: staffDetails.staff_name || "",
      telephone: staffDetails.telephone || "",
      office_id: staffDetails.office_id || staffDetails.office?.id || staffDetails.office?.office_id || "",
      role_id: staffDetails.role_id || staffDetails.role?.id || staffDetails.role?.role_id || "",
      department_id:
        staffDetails.department_id ||
        staffDetails.department?.id ||
        staffDetails.department?.department_id ||
        "",
      joined_at: toDateInputValue(staffDetails.joined_at),
      blood_group: staffDetails.blood_group || "",
      annual_leave_days:
        staffDetails.annual_leave_days ??
        staffDetails.contract?.annual_leave_days ??
        "",
    });

    setShowEditStaffDetailsModal(true);
  };

  const handleUpdateStaffDetails = () => {
    if (!selectedStaffId) {
      cogoToast.error("Staff ID is missing", { hideAfter: 3 });
      return;
    }

    const payload = {
      staff_id: selectedStaffId,
      staff_name: (staffEditForm.staff_name || "").trim(),
      telephone: (staffEditForm.telephone || "").trim(),
      office_id: staffEditForm.office_id,
      role_id: staffEditForm.role_id,
      department_id: staffEditForm.department_id,
      joined_at: staffEditForm.joined_at,
      blood_group: staffEditForm.blood_group || "",
      annual_leave_days:
        staffEditForm.annual_leave_days === ""
          ? null
          : Number(staffEditForm.annual_leave_days),
    };

    if (
      !payload.staff_name ||
      !payload.telephone ||
      !payload.joined_at ||
      !payload.office_id ||
      !payload.role_id ||
      !payload.department_id
    ) {
      cogoToast.error("Please fill Staff Name, Phone, Joined Date, Office, Role, and Department", { hideAfter: 4 });
      return;
    }

    setIsUpdatingStaffDetails(true);
    genericPost("hrm/update-staff-details", payload)
      .then((res) => {
        setIsUpdatingStaffDetails(false);
        const response = res?.data || {};
        if (res.status === 200 && response.status === SUCCESS_RESULT) {
          cogoToast.success(response.message || "Staff details updated successfully", { hideAfter: 4 });
          setShowEditStaffDetailsModal(false);
          refreshStaffDetails();
          fetch_data();
        } else {
          cogoToast.error(response.message || "Failed to update staff details", { hideAfter: 5 });
        }
      })
      .catch((err) => {
        setIsUpdatingStaffDetails(false);
        const errorMessage = err?.response?.data?.message || "Something went wrong, please try again.";
        cogoToast.error(errorMessage, { hideAfter: 5 });
      });
  };

  const handleToggleSelection = (staffId) => {
    setSelectedStaffIds((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(staffId)) {
        newSet.delete(staffId);
      } else {
        newSet.add(staffId);
      }
      return newSet;
    });
  };

  const handleSelectAll = () => {
    if (selectedStaffIds.size === filteredData.length) {
      // Deselect all
      setSelectedStaffIds(new Set());
    } else {
      // Select all
      const allIds = new Set(filteredData.map((emp) => emp.id).filter(Boolean));
      setSelectedStaffIds(allIds);
    }
  };

  const handleBulkStatusUpdate = (newStatus) => {
    if (selectedStaffIds.size === 0) {
      cogoToast.error("Please select at least one staff member", { hideAfter: 3 });
      return;
    }

    const staffIdArray = Array.from(selectedStaffIds);
    const statusText = newStatus === 10001 ? "activate" : "deactivate";
    
    Swal.fire({
      title: `Are you sure?`,
      text: `You are about to ${statusText} ${staffIdArray.length} staff member(s).`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: newStatus === 10001 ? "#28a745" : "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, ${statusText} them!`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsBulkUpdating(true);

        UpdateStaffStatusApi({
          staff_id: staffIdArray,
          status: newStatus,
        })
          .then((res) => {
            setIsBulkUpdating(false);
            if (res.status === 200) {
              const response = res.data;
              if (response.status === SUCCESS_RESULT) {
                cogoToast.success(
                  `Successfully ${statusText}d ${staffIdArray.length} staff member(s)`,
                  { hideAfter: 3 }
                );
                // Clear selection
                setSelectedStaffIds(new Set());
                // Refresh the list
                fetch_data();
              } else {
                cogoToast.error(response.message || `Failed to ${statusText} staff`, {
                  hideAfter: 5,
                });
              }
            } else {
              cogoToast.error(res.message || `Failed to ${statusText} staff`, {
                hideAfter: 5,
              });
            }
          })
          .catch((err) => {
            setIsBulkUpdating(false);
            const errorMessage =
              err?.response?.data?.message || "Something went wrong, please try again.";
            cogoToast.error(errorMessage, { hideAfter: 5 });
          });
      }
    });
  };

  return (
    <div style={{ padding: "10px" }}>
      <div className="page-header d-print-none mb-2">
        <div className="container-xlxx">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title" style={{ fontSize: "0.8rem", marginBottom: "0.25rem", fontWeight: "600" }}>Employee List</h2>
              <div className="text-muted" style={{ fontSize: "0.75rem" }}>View and manage employee information</div>
        </div>
          </div>
        </div>
      </div>

      <div className="container-xlx">
        <Card className="shadow-sm">
          <CardHeader style={{ padding: "0.75rem" }}>
            <Row>
              <Col md={6}>
                <div className="input-group" style={{ fontSize: "0.85rem" }}>
                  <span className="input-group-text" style={{ padding: "0.4rem 0.6rem", fontSize: "0.85rem" }}>
                    <FaSearch />
                  </span>
                  <Input
                    type="text"
                    placeholder="Search by staff ID, name, email, office, designation, department, joined at..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ fontSize: "0.85rem", padding: "0.4rem 0.6rem" }}
                  />
                </div>
              </Col>
              <Col md={3}>
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <Button
                    onClick={() => setStatusFilter(10001)}
                    style={{
                      background: statusFilter === 10001 
                        ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" 
                        : "linear-gradient(135deg, #e0e0e0 0%, #b0b0b0 100%)",
                      color: statusFilter === 10001 ? "white" : "#666",
                      border: "none",
                      borderRadius: "8px",
                      padding: "0.5rem 1.5rem",
                      fontWeight: statusFilter === 10001 ? "600" : "500",
                      boxShadow: statusFilter === 10001 
                        ? "0 4px 12px rgba(102, 126, 234, 0.4)" 
                        : "0 2px 4px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (statusFilter !== 10001) {
                        e.target.style.background = "linear-gradient(135deg, #d0d0d0 0%, #a0a0a0 100%)";
                        e.target.style.transform = "translateY(-1px)";
                        e.target.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.15)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (statusFilter !== 10001) {
                        e.target.style.background = "linear-gradient(135deg, #e0e0e0 0%, #b0b0b0 100%)";
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                      }
                    }}
                  >
                    Active
                  </Button>
                  <Button
                    onClick={() => setStatusFilter(10002)}
                    style={{
                      background: statusFilter === 10002 
                        ? "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" 
                        : "linear-gradient(135deg, #e0e0e0 0%, #b0b0b0 100%)",
                      color: statusFilter === 10002 ? "white" : "#666",
                      border: "none",
                      borderRadius: "6px",
                      padding: "0.35rem 1rem",
                      fontSize: "0.8rem",
                      fontWeight: statusFilter === 10002 ? "600" : "500",
                      boxShadow: statusFilter === 10002 
                        ? "0 4px 12px rgba(240, 147, 251, 0.4)" 
                        : "0 2px 4px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (statusFilter !== 10002) {
                        e.target.style.background = "linear-gradient(135deg, #d0d0d0 0%, #a0a0a0 100%)";
                        e.target.style.transform = "translateY(-1px)";
                        e.target.style.boxShadow = "0 3px 6px rgba(0, 0, 0, 0.15)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (statusFilter !== 10002) {
                        e.target.style.background = "linear-gradient(135deg, #e0e0e0 0%, #b0b0b0 100%)";
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                      }
                    }}
                  >
                    Inactive
                  </Button>
                </div>
              </Col> 
              <Col md={3} className="text-end">
                {filteredData.length > 0 && (
                  <Button 
                    onClick={handleExport}
                    style={{
                      background: "linear-gradient(135deg,rgb(43, 79, 157) 0%,rgb(0, 103, 84) 100%)",
                      border: "none",
                      borderRadius: "6px",
                      padding: "0.35rem 1rem",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      boxShadow: "0 4px 12px rgba(67, 233, 123, 0.3)",
                      transition: "all 0.3s ease",
                      color: "white",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow = "0 6px 16px rgba(67, 233, 123, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 4px 12px rgba(67, 233, 123, 0.3)";
                    }}
                  >
                    <FaFileExport style={{ marginRight: "8px" }} />
                    Export as Excel
                  </Button>
                )}
              </Col>
            </Row>
            {selectedStaffIds.size > 0 && (
              <Row className="mt-3">
                <Col md={12}>
                  <div style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "0.75rem",
                    padding: "0.75rem",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0"
                  }}>
                    <div style={{ 
                      fontWeight: "600", 
                      color: "#495057",
                      fontSize: "0.9rem"
                    }}>
                      {selectedStaffIds.size} staff member(s) selected
                    </div>
                    <div style={{ display: "flex", gap: "0.5rem", marginLeft: "auto" }}>
                      <Button
                        color="success"
                        size="sm"
                        onClick={() => handleBulkStatusUpdate(10001)}
                        disabled={isBulkUpdating}
                        style={{
                          background: "linear-gradient(135deg, #56ab2f 0%, #a8e063 100%)",
                          border: "none",
                          fontWeight: "600",
                        }}
                      >
                        {isBulkUpdating ? (
                          <>
                            <PulseLoader color="white" loading={true} size={5} style={{ marginRight: "8px" }} />
                            Updating...
                          </>
                        ) : (
                          "Activate Selected"
                        )}
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleBulkStatusUpdate(10002)}
                        disabled={isBulkUpdating}
                        style={{
                          background: "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)",
                          border: "none",
                          fontWeight: "600",
                        }}
                      >
                        {isBulkUpdating ? (
                          <>
                            <PulseLoader color="white" loading={true} size={5} style={{ marginRight: "8px" }} />
                            Updating...
                          </>
                        ) : (
                          "Deactivate Selected"
                        )}
                      </Button>
                      <Button
                        color="secondary"
                        size="sm"
                        onClick={() => setSelectedStaffIds(new Set())}
                        disabled={isBulkUpdating}
                        style={{
                          background: "linear-gradient(135deg, #868f96 0%, #596164 100%)",
                          border: "none",
                          fontWeight: "600",
                        }}
                      >
                        Clear Selection
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </CardHeader>
          <CardBody style={{ padding: "0.75rem" }}>
            {is_processing ? (
              <div className="text-center py-3">
                <PulseLoader color="#4E6ECF" loading={true} size={12} />
                <p className="mt-2 text-muted" style={{ fontSize: "0.85rem" }}>Loading employees...</p>
              </div>
            ) : filteredData.length === 0 ? (
              <div className="text-center py-3">
                <p className="text-muted" style={{ fontSize: "0.85rem" }}>
                  {searchTerm
                    ? "No employees found matching your search"
                    : "No employees found"}
                </p>
              </div>
            ) : (
              <div className="table-responsive">
                <Table hover striped bordered size="sm" style={{ fontSize: "0.8rem" }}>
                  <thead>
                    <tr>
                      <th style={{ padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal", width: "40px" }}>
                        <input
                          type="checkbox"
                          checked={filteredData.length > 0 && selectedStaffIds.size === filteredData.length}
                          onChange={handleSelectAll}
                          style={{ cursor: "pointer" }}
                          title="Select all"
                        />
                      </th>
                      <th style={{ padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}>#</th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("staff_id")}
                      >
                        Staff ID {getSortIcon("staff_id")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("staff_name")}
                      >
                        Staff Name {getSortIcon("staff_name")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("email")}
                      >
                        Email {getSortIcon("email")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("telephone")}
                      >
                        Telephone {getSortIcon("telephone")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("designation")}
                      >
                        Designation {getSortIcon("designation")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("department_name")}
                      >
                        Department {getSortIcon("department_name")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("joined_at")}
                      >
                        Joined At {getSortIcon("joined_at")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("office")}
                      >
                        Office {getSortIcon("office")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("contract_start_date")}
                      >
                        Contract {getSortIcon("contract_start_date")}
                      </th>
                      <th 
                        style={{ cursor: "pointer", userSelect: "none", padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}
                        onClick={() => handleSort("files_count")}
                      >
                        Files {getSortIcon("files_count")}
                      </th>
                      <th style={{ padding: "0.4rem", fontSize: "0.8rem", fontWeight: "normal" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((employee, index) => {
                      const contractColor = getContractStatusColor(
                        employee.contract_expires_after
                      );
                      return (
                        <tr
                          key={employee.id || index}
                          onDoubleClick={() => handleOpenDetails(employee.id)}
                          style={{ cursor: "pointer" }}
                        >
                          <td 
                            style={{ padding: "0.4rem" }}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <input
                              type="checkbox"
                              checked={employee.id && selectedStaffIds.has(employee.id)}
                              onChange={() => employee.id && handleToggleSelection(employee.id)}
                              style={{ cursor: "pointer" }}
                            />
                          </td>
                          <td style={{ padding: "0.4rem" }}>{index + 1}</td>
                          <td style={{ padding: "0.4rem" }}>{employee.staff_id || "-"}</td>
                          <td style={{ padding: "0.4rem" }}>
                            <strong style={{ fontSize: "0.8rem" }}>{employee.staff_name || "-"}</strong>
                          </td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.email || "-"}</td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.telephone || "-"}</td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.designation || "-"}</td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.department_name || "-"}</td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.joined_at ? formatDate(employee.joined_at) : "-"}</td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.office || "-"}</td>
                          <td
                            style={{
                              backgroundColor: contractColor || "transparent",
                              color: contractColor ? "white" : "inherit",
                              fontWeight: contractColor ? "bold" : "normal",
                              padding: "0.4rem",
                              fontSize: "0.8rem",
                            }}
                          >
                            {formatDate(employee.contract_start_date)} - 
                            {formatDate(employee.contract_end_date)}
                          </td>
                          <td style={{ padding: "0.4rem", fontSize: "0.8rem" }}>{employee.files_count || 0}</td>
                          <td style={{ padding: "0.4rem" }}> 
                            <Button
                              color="primary"
                              size="sm"
                              style={{ fontSize: "0.7rem", padding: "0.2rem 0.5rem" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpenDetails(employee.id);
                              }}
                            >
                              Details <FaArrowRight style={{ marginLeft: "2px", fontSize: "0.7rem" }} />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div className="mt-2 text-muted" style={{ fontSize: "0.75rem", padding: "0.25rem 0" }}>
                  Showing <strong>{filteredData.length}</strong> of{" "}
                  <strong>{rowData.length}</strong> employee(s)
                  {searchTerm && (
                    <span className="ms-2 text-primary">
                      (filtered by "{searchTerm}")
                    </span>
          )}
        </div>
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      
      {/* Side Sliding Panel */}
      {isPanelOpen && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "calc(100vw / 0.80)",
              height: "calc(90vh / 0.70)",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1040,
              transition: "opacity 0.3s ease",
            }}
            onClick={handleClosePanel}
          />

          {/* Side Panel */}
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "calc(80vw / 0.80)",
              height: "calc(100vh / 0.70)",
              maxHeight: "calc(100vh / 0.80)",
              backgroundColor: "white",
              boxShadow: "-4px 0 16px rgba(0, 0, 0, 0.2)",
              zIndex: 1050,
              overflowY: "auto",
              transform: isPanelOpen ? "translateX(0)" : "translateX(100%)",
              transition: "transform 0.3s ease",
            }}
          >
            {/* Panel Header */}
            <div
              style={{
                padding: "1.5rem",
                borderBottom: "1px solid #e0e0e0",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                position: "sticky",
                top: 0,
                zIndex: 1,
              }}
            >
              <h4 className="mb-0" style={{ color: "white", fontWeight: "600" }}>
                Staff Details
              </h4>
              <Button
                color="link"
                onClick={handleClosePanel}
                style={{ color: "white", padding: 0 }}
              >
                <FaTimes size={20} />
              </Button>
            </div>

            {/* Panel Body */}
            <div style={{ padding: "1.5rem" }}>
              {isLoadingDetails ? (
                <div className="text-center py-5">
                  <PulseLoader color="#667eea" loading={true} size={15} />
                  <p className="mt-3 text-muted">Loading staff details...</p>
                </div>
              ) : staffDetails ? (
                <div>
                  {/* Basic Information Card with Profile on Left and Details on Right */}
                  <Row className="mb-2">
                    <Col md={12}>
                      <Card style={{ border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                        <CardHeader
                          style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            color: "white",
                            fontWeight: "600",
                            padding: "0.75rem 1rem",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px" }}>
                            <span>Basic Information</span>
                            <Button
                              outline
                              onClick={handleOpenEditStaffDetails}
                              style={{
                                border: "1px solid rgba(255,255,255,0.95)",
                                color: "white",
                                backgroundColor: "rgba(255,255,255,0.12)",
                                padding: "6px 12px",
                                fontWeight: 700,
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                lineHeight: 1,
                              }}
                              disabled={!staffDetails}
                              title="Edit staff details"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.20)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.12)";
                              }}
                            >
                              <FaEdit />
                              Edit
                            </Button>
                          </div>
                        </CardHeader>
                        <CardBody style={{ padding: "1rem" }}>
                          <Row>
                            {/* Left Side - Profile Picture and Name */}
                            <Col md={4}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "flex-start",
                                  gap: "1rem",
                                  padding: "0.5rem",
                                }}
                              >
                                {staffDetails.photo && (
                                  <div
                                    style={{
                                      width: "120px",
                                      height: "120px",
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      border: "4px solid #667eea",
                                      flexShrink: 0,
                                    }}
                                  >
                                    <img
                                      src={`data:image/png;base64,${staffDetails.photo}`}
                                      alt={staffDetails.staff_name}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                )}
                                <div style={{ flex: 1 }}>
                                  <h4 style={{ margin: "0 0 0.5rem 0", color: "#333", fontWeight: "600", fontSize: "1.25rem" }}>
                                    {staffDetails.staff_name || "N/A"}
                                  </h4>
                                  <p style={{ margin: "0 0 0.25rem 0", color: "#666", fontSize: "1rem" }}>
                                    {staffDetails.role_name || "N/A"}
                                  </p>
                                  <p style={{ margin: 0, color: "#999", fontSize: "0.85rem" }}>
                                    {staffDetails.department?.department_name || staffDetails.department_name || "N/A"} • {staffDetails.office_name || "N/A"}
                                  </p>
                                </div>
                              </div>
                            </Col>
                            {/* Right Side - Details Table */}
                            <Col md={8}>
                              <Row>
                                <Col md={6}>
                                  <Table borderless size="sm" style={{ marginBottom: 0 }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "35%", fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          Staff Code
                                        </td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          <strong>{staffDetails.staff_code || staffDetails.staff_id || "N/A"}</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>Email</td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>{staffDetails.email || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>Phone</td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>{staffDetails.telephone || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>Gender</td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>{staffDetails.gender || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>Blood Group</td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>{staffDetails.blood_group || "N/A"}</td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Col>
                                <Col md={6}>
                                  <Table borderless size="sm" style={{ marginBottom: 0 }}>
                                    <tbody>
                                      <tr>
                                        <td style={{ width: "35%", fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          Passport
                                        </td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>{staffDetails.passport || "N/A"}</td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          Status
                                        </td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                            <Badge color={staffDetails.status === 10001 ? "success" : "secondary"}>
                                              {staffDetails.status === 10001 ? "Active" : "Inactive"}
                                            </Badge>
                                            <Button
                                              color={staffDetails.status === 10001 ? "danger" : "success"}
                                              size="sm"
                                              onClick={() => setShowStatusModal(true)}
                                              style={{
                                                fontSize: "0.75rem",
                                                padding: "0.25rem 0.5rem",
                                                height: "auto",
                                              }}
                                            >
                                              {staffDetails.status === 10001 ? "Deactivate" : "Activate"}
                                            </Button>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          Current Budget
                                        </td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          <strong>
                                            {staffDetails.current_budget_amount
                                              ? `$${Number(staffDetails.current_budget_amount).toFixed(2)}`
                                              : "N/A"}
                                          </strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ fontWeight: "600", color: "#666", padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>Joined At</td>
                                        <td style={{ padding: "0.25rem 0.5rem", fontSize: "0.9rem" }}>
                                          <span>{formatDate(staffDetails.joined_at)}</span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </Table>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* Three Column Layout: Salary/Contract, Leave, Files */}
                  <Row className="mb-3">
                    {/* Salary & Contract Details Column */}
                    <Col md={4}>
                      <Card style={{ border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", height: "100%" }}>
                        <CardHeader
                          style={{
                            background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                            color: "white",
                            fontWeight: "600",
                          }}
                        >
                          Salary & Contract
                        </CardHeader>
                        <CardBody>
                          {/* Salary Information */}
                          <div className="mb-3">
                            <h6 style={{ color: "#666", marginBottom: "0.75rem" }}>Salary Details</h6>
                            <Table borderless size="sm">
                              <tbody>
                                <tr>
                                  <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                    Basic Salary
                                  </td>
                                  <td>
                                    <strong>
                                      {staffDetails.basic_salary
                                        ? `$${Number(staffDetails.basic_salary).toFixed(2)}`
                                        : "N/A"}
                                    </strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                    Gross Salary
                                  </td>
                                  <td>
                                    <strong>
                                      {staffDetails.gross_salary
                                        ? `$${Number(staffDetails.gross_salary).toFixed(2)}`
                                        : "N/A"}
                                    </strong>
                                  </td>
                                </tr>
                                {staffDetails.contract?.contracted_salary && (
                                  <tr>
                                    <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                      Contracted Salary
                                    </td>
                                    <td>
                                      <strong>
                                        ${Number(staffDetails.contract.contracted_salary).toFixed(2)}
                                      </strong>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>

                          <hr />

                          {/* Contract Information */}
                          <div>
                            <h6 style={{ color: "#666", marginBottom: "0.75rem" }}>Contract Details</h6>
                            <Table borderless size="sm">
                              <tbody>
                                <tr>
                                  <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                    Start Date
                                  </td>
                                  <td>
                                    {formatDate(
                                      staffDetails.contract?.start_date ||
                                        staffDetails.contract_start ||
                                        staffDetails.contract_start_date
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                    End Date
                                  </td>
                                  <td
                                    style={{
                                      color: getContractStatusColor(
                                        staffDetails.contract_expires_after
                                      ) || "inherit",
                                      fontWeight: getContractStatusColor(
                                        staffDetails.contract_expires_after
                                      )
                                        ? "bold"
                                        : "normal",
                                    }}
                                  >
                                    {formatDate(
                                      staffDetails.contract?.end_date ||
                                        staffDetails.contract_end ||
                                        staffDetails.contract_end_date
                                    )}
                                  </td>
                                </tr>
                                {staffDetails.contract?.annual_leave_days && (
                                  <tr>
                                    <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                      Annual Leave Days
                                    </td>
                                    <td>
                                      <Badge color="info">
                                        {staffDetails.contract.annual_leave_days} days
                                      </Badge>
                                    </td>
                                  </tr>
                                )}
                                {staffDetails.contract?.status !== undefined && (
                                  <tr>
                                    <td style={{ fontWeight: "600", color: "#666", fontSize: "0.85rem" }}>
                                      Contract Status
                                    </td>
                                    <td>
                                      <Badge
                                        color={staffDetails.contract.status === 10001 ? "success" : "secondary"}
                                      >
                                        {staffDetails.contract.status === 10001 ? "Active" : "Inactive"}
                                      </Badge>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </div>

                          {/* Allowances */}
                          {staffDetails.staff_allowances && staffDetails.staff_allowances.length > 0 && (
                            <>
                              <hr />
                              <div>
                                <h6 style={{ color: "#666", marginBottom: "0.75rem" }}>Allowances</h6>
                                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                  {staffDetails.staff_allowances.map((allowance, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        padding: "0.5rem",
                                        marginBottom: "0.5rem",
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                                        {allowance.name}
                                      </div>
                                      <div style={{ color: "#666", fontSize: "0.85rem" }}>
                                        ${Number(allowance.amount).toFixed(2)} ({allowance.type})
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}

                          {/* Assigned Taxes */}
                          {staffDetails.Assigned_taxes && staffDetails.Assigned_taxes.length > 0 && (
                            <>
                              <hr />
                              <div>
                                <h6 style={{ color: "#666", marginBottom: "0.75rem" }}>Taxes</h6>
                                <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                                  {staffDetails.Assigned_taxes.map((tax, idx) => (
                                    <div
                                      key={idx}
                                      style={{
                                        padding: "0.5rem",
                                        marginBottom: "0.5rem",
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      <div style={{ fontWeight: "600", fontSize: "0.9rem" }}>
                                        {tax.tax_name}
                                      </div>
                                      <div style={{ color: "#666", fontSize: "0.75rem" }}>
                                        Assigned by: {tax.assigned_by}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Leave Details Column */}
                    <Col md={4}>
                      <Card style={{ border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", height: "100%" }}>
                        <CardHeader
                          style={{
                            background: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
                            color: "white",
                            fontWeight: "600",
                          }}
                        >
                          Leave Details
                        </CardHeader>
                        <CardBody>
                          {staffDetails.leave_data && staffDetails.leave_data.length > 0 ? (
                            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                              {staffDetails.leave_data.map((leave, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    padding: "0.75rem",
                                    marginBottom: "0.75rem",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "6px",
                                    border: "1px solid #e0e0e0",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    <div style={{ fontWeight: "600", fontSize: "0.95rem" }}>
                                      {leave.name}
                                    </div>
                                    <Badge
                                      color={
                                        Number(leave.remaining_days) > 5
                                          ? "success"
                                          : Number(leave.remaining_days) > 0
                                          ? "warning"
                                          : "danger"
                                      }
                                    >
                                      {leave.remaining_days} / {leave.allowable_leave_days}
                                    </Badge>
                                  </div>
                                  <div style={{ fontSize: "0.85rem", color: "#666" }}>
                                    <div>
                                      Remaining: <strong>{leave.remaining_days} days</strong>
                                    </div>
                                    <div>
                                      Requested: {leave.requested_days} days
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted text-center">No leave data available</p>
                          )}
                        </CardBody>
                      </Card>
                    </Col>

                    {/* Staff Files Column */}
                    <Col md={4}>
                      <Card style={{ border: "none", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", height: "100%" }}>
                        <CardHeader
                          style={{
                            background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                            color: "white",
                            fontWeight: "600",
                          }}
                        >
                          Staff Files
                        </CardHeader>
                        <CardBody>
                          {!showUploadForm ? (
                            <>
                              {/* Files List View */}
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                                <h6 style={{ color: "#666", margin: 0 }}>Staff Files</h6>
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => setShowUploadForm(true)}
                                  style={{
                                    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                    border: "none",
                                  }}
                                >
                                  <FaUpload style={{ marginRight: "8px" }} />
                                  Upload File
                                </Button>
                              </div>

                              <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                                {isLoadingFiles ? (
                                  <div className="text-center py-4">
                                    <PulseLoader color="#fa709a" loading={true} size={8} />
                                    <p className="text-muted mt-2" style={{ fontSize: "0.9rem" }}>
                                      Loading files...
                                    </p>
                                  </div>
                                ) : staffFiles.length > 0 ? (
                                  staffFiles.map((file) => (
                                    <div
                                      key={file.id}
                                      style={{
                                        padding: "0.75rem",
                                        marginBottom: "0.75rem",
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "6px",
                                        border: "1px solid #e0e0e0",
                                      }}
                                    >
                                      <div style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
                                        <FaFile style={{ color: "#667eea", fontSize: "1.2rem", marginTop: "0.2rem" }} />
                                        <div style={{ flex: 1 }}>
                                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.5rem" }}>
                  <div>
                                              <div style={{ fontWeight: "600", fontSize: "0.95rem", color: "#333" }}>
                                                {file.document_name}
                                              </div>
                                              {file.file_type && (
                                                <Badge color="info" style={{ fontSize: "0.7rem", marginTop: "0.25rem" }}>
                                                  {file.file_type.name}
                                                </Badge>
                                              )}
                                            </div>
                                            {file.is_confidential && (
                                              <Badge color="warning" style={{ fontSize: "0.7rem" }}>
                                                Confidential
                                              </Badge>
                                            )}
                                          </div>
                                          <div style={{ fontSize: "0.8rem", color: "#666", marginBottom: "0.25rem" }}>
                                            <div>
                                              <strong>File:</strong> {file.file_name} ({file.document_type?.toUpperCase()})
                                            </div>
                                            <div>
                                              <strong>Size:</strong> {(file.file_size / 1024).toFixed(2)} KB
                                            </div>
                                            {file.description && (
                                              <div style={{ marginTop: "0.25rem", fontStyle: "italic" }}>
                                                {file.description}
                                              </div>
                                            )}
                                            {file.category && (
                                              <div>
                                                <strong>Category:</strong> {file.category}
                                              </div>
                                            )}
                                          </div>
                                          <div style={{ fontSize: "0.75rem", color: "#999", marginTop: "0.5rem", paddingTop: "0.5rem", borderTop: "1px solid #e0e0e0" }}>
                                            <div>
                                              Uploaded by: <strong>{file.uploaded_by?.name || "N/A"}</strong>
                                            </div>
                                            <div>
                                              {formatDate(file.created_at)}
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginLeft: "0.5rem" }}>
                                          <Button
                                            color="primary"
                                            size="sm"
                                            onClick={() => handleDownloadFile(file)}
                                            style={{
                                              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                              border: "none",
                                              minWidth: "80px",
                                            }}
                                            title="Open file in new tab"
                                          >
                                            <FaDownload style={{ marginRight: "4px" }} />
                                            Open
                                          </Button>
                                          <Button
                                            color="danger"
                                            size="sm"
                                            onClick={() => handleDeleteFile(file)}
                                            style={{
                                              minWidth: "80px",
                                            }}
                                            title="Delete file"
                                          >
                                            <FaTrash style={{ marginRight: "4px" }} />
                                            Delete
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className="text-center py-4">
                                    <FaFile size={48} style={{ color: "#ddd", marginBottom: "0.5rem" }} />
                                    <p className="text-muted" style={{ fontSize: "0.9rem" }}>
                                      No files uploaded yet
                                    </p>
                                  </div>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              {/* Upload Form View */}
                              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                                <h6 style={{ color: "#666", margin: 0 }}>Upload New File</h6>
                                <Button
                                  color="secondary"
                                  size="sm"
                                  outline
                                  onClick={() => {
                                    setShowUploadForm(false);
                                    setUploadForm({
                                      file: null,
                                      file_type_id: "",
                                      document_name: "",
                                      description: "",
                                    });
                                    if (fileInputRef.current) {
                                      fileInputRef.current.value = "";
                                    }
                                  }}
                                >
                                  <FaTimes style={{ marginRight: "4px" }} />
                                  Cancel
                                </Button>
                              </div>

                              <div>
                                <Label for="file_type_id" style={{ fontSize: "0.85rem", fontWeight: "600" }}>
                                  File Type <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="select"
                                  name="file_type_id"
                                  id="file_type_id"
                                  value={uploadForm.file_type_id}
                                  onChange={handleUploadFormChange}
                                  style={{ fontSize: "0.85rem", marginBottom: "0.75rem" }}
                                  disabled={isLoadingFileTypes}
                                >
                                  <option value="">Select file type...</option>
                                  {fileTypes.map((type) => (
                                    <option key={type.id} value={type.id}>
                                      {type.name}
                                    </option>
                                  ))}
                                </Input>

                                <Label for="document_name" style={{ fontSize: "0.85rem", fontWeight: "600" }}>
                                  Document Name <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="text"
                                  name="document_name"
                                  id="document_name"
                                  placeholder="Enter document name"
                                  value={uploadForm.document_name}
                                  onChange={handleUploadFormChange}
                                  style={{ fontSize: "0.85rem", marginBottom: "0.75rem" }}
                                />

                                <Label for="description" style={{ fontSize: "0.85rem", fontWeight: "600" }}>
                                  Description
                                </Label>
                                <Input
                                  type="textarea"
                                  name="description"
                                  id="description"
                                  placeholder="Enter description (optional)"
                                  value={uploadForm.description}
                                  onChange={handleUploadFormChange}
                                  rows={2}
                                  style={{ fontSize: "0.85rem", marginBottom: "0.75rem" }}
                                />

                                <Label for="file" style={{ fontSize: "0.85rem", fontWeight: "600" }}>
                                  File <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="file"
                                  name="file"
                                  id="file"
                                  innerRef={fileInputRef}
                                  onChange={handleUploadFormChange}
                                  style={{ fontSize: "0.85rem", marginBottom: "0.75rem" }}
                                />
                                {uploadForm.file && (
                                  <small className="text-muted" style={{ display: "block", marginBottom: "0.75rem" }}>
                                    Selected: {uploadForm.file.name} ({(uploadForm.file.size / 1024).toFixed(2)} KB)
                                  </small>
                                )}

                                <Button
                                  color="primary"
                                  size="sm"
                                  block
                                  onClick={handleFileUpload}
                                  disabled={isUploading || !uploadForm.file || !uploadForm.file_type_id || !uploadForm.document_name}
                                  style={{
                                    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                    border: "none",
                                  }}
                                >
                                  {isUploading ? (
                                    <>
                                      <PulseLoader color="white" loading={true} size={5} style={{ marginRight: "8px" }} />
                                      Uploading...
                                    </>
                                  ) : (
                                    <>
                                      <FaUpload style={{ marginRight: "8px" }} />
                                      Upload File
                                    </>
                                  )}
                                </Button>
                              </div>
                            </>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* View Full Profile Button */}
                  <div className="mt-4">
                    <Button
                      color="primary"
                      block
                    onClick={() => {
                        handleClosePanel();
                      history.push({
                        pathname: LOCAL_PATHS.EMPLOYEE_PROFILE,
                          state: { _staff_id: selectedStaffId },
                      });
                    }}
                      style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        border: "none",
                      }}
                    >
                      View Full Profile <FaArrowRight style={{ marginLeft: "8px" }} />
                    </Button>
                  </div>
                </div>
              ) : (
                <div className="text-center py-5">
                  <p className="text-muted">No details available</p>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {/* Status Update Confirmation Modal */}
      <Modal isOpen={showStatusModal} toggle={() => setShowStatusModal(false)}>
        <ModalHeader toggle={() => setShowStatusModal(false)}>
          {staffDetails?.status === 10001 ? "Deactivate Staff" : "Activate Staff"}
        </ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to{" "}
            <strong>{staffDetails?.status === 10001 ? "deactivate" : "activate"}</strong>{" "}
            <strong>{staffDetails?.staff_name || "this staff member"}</strong>?
          </p>
          {staffDetails?.status === 10001 && (
            <p className="text-warning">
              <small>
                Deactivating this staff member will change their status to inactive.
              </small>
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowStatusModal(false)}
            disabled={isUpdatingStatus}
          >
            Cancel
          </Button>
          <Button
            color={staffDetails?.status === 10001 ? "danger" : "success"}
            onClick={handleStatusUpdate}
            disabled={isUpdatingStatus}
          >
            {isUpdatingStatus ? (
              <>
                <PulseLoader color="white" loading={true} size={5} style={{ marginRight: "8px" }} />
                {staffDetails?.status === 10001 ? "Deactivating..." : "Activating..."}
              </>
            ) : (
              <>
                {staffDetails?.status === 10001 ? "Deactivate" : "Activate"}
              </>
            )}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit Staff Details Modal */}
      <Modal isOpen={showEditStaffDetailsModal} toggle={() => setShowEditStaffDetailsModal(false)} size="lg">
        <ModalHeader toggle={() => setShowEditStaffDetailsModal(false)}>
          Edit Staff Details
        </ModalHeader>
        <ModalBody>
          <Row className="g-3">
            <Col md={6}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Staff Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                value={staffEditForm.staff_name}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, staff_name: e.target.value }))}
              />
            </Col>

            <Col md={6}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Phone <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                value={staffEditForm.telephone}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, telephone: e.target.value }))}
              />
            </Col>

            <Col md={6}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Blood Group
              </Label>
              <Input
                type="select"
                value={staffEditForm.blood_group}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, blood_group: e.target.value }))}
              >
                <option value="">Select blood group</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
              </Input>
              <small className="text-muted">Current: {staffDetails?.blood_group || "N/A"}</small>
            </Col>

            <Col md={4}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Office <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                value={staffEditForm.office_id}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, office_id: e.target.value }))}
              >
                <option value="">Select office</option>
                {(officesList || []).map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.office_name}
                  </option>
                ))}
              </Input>
              <small className="text-muted">
                Current: {staffDetails?.office_name || staffDetails?.office?.office_name || "N/A"}
              </small>
            </Col>

            <Col md={4}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Role <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                value={staffEditForm.role_id}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, role_id: e.target.value }))}
              >
                <option value="">Select role</option>
                {(rolesList || []).map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.role_name}
                  </option>
                ))}
              </Input>
              <small className="text-muted">Current: {staffDetails?.role_name || staffDetails?.role?.role_name || "N/A"}</small>
            </Col>

            <Col md={4}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Department <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                value={staffEditForm.department_id}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, department_id: e.target.value }))}
              >
                <option value="">Select department</option>
                {(departmentsList || []).map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.department_name}
                  </option>
                ))}
              </Input>
              <small className="text-muted">
                Current: {staffDetails?.department?.department_name || staffDetails?.department_name || "N/A"}
              </small>
            </Col>

            <Col md={6}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Joined At <span className="text-danger">*</span>
              </Label>
              <Input
                type="date"
                value={staffEditForm.joined_at}
                onChange={(e) => setStaffEditForm((prev) => ({ ...prev, joined_at: e.target.value }))}
              />
              <small className="text-muted" style={{ display: "block", marginTop: "0.5rem" }}>
                Current: {staffDetails?.joined_at ? formatDate(staffDetails.joined_at) : "N/A"}
              </small>
            </Col>

            <Col md={6}>
              <Label style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                Annual Leave Days
              </Label>
              <Input
                type="number"
                min="0"
                step="1"
                value={staffEditForm.annual_leave_days}
                onChange={(e) =>
                  setStaffEditForm((prev) => ({ ...prev, annual_leave_days: e.target.value }))
                }
                placeholder="e.g. 21"
              />
              <small className="text-muted" style={{ display: "block", marginTop: "0.5rem" }}>
                Current:{" "}
                {staffDetails?.annual_leave_days ??
                staffDetails?.contract?.annual_leave_days ??
                "N/A"}
              </small>
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setShowEditStaffDetailsModal(false)} disabled={isUpdatingStaffDetails}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={handleUpdateStaffDetails}
            disabled={isUpdatingStaffDetails}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              border: "none",
            }}
          >
            {isUpdatingStaffDetails ? (
              <>
                <PulseLoader color="white" loading={true} size={5} style={{ marginRight: "8px" }} />
                Updating...
              </>
            ) : (
              "Update Staff Details"
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EmployeeList;
